import { ITableDTO } from './ITableDTO';

export class TableDataDTO<TDTO extends ITableDTO> {
    public Count: number;
    public Items: Array<TDTO>;
} 